import React, { Component, useState } from 'react';
import { useEffect } from 'react';
import { useTable, usePagination } from 'react-table'
import './TableStatus.css'
import { useTranslation } from 'react-i18next';
import TableEagleEarnings from './TableEagleEarnings';
import EagleRedirect from './EagleRedirect';
  



const TableEagleStatus = (props) => {
    const { t } = useTranslation();
    const columns = React.useMemo(
        () => [{ Header: 'Submission', accessor: 'eagleSubmission' },  { Header: 'Status', accessor: 'status' }, { Header: 'Reason', accessor: 'statusReason' }, { Header: 'Submission Date Time', accessor: 'submissionDateTime' }],
        [t]
    );
    
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        populateTableStatusData();
    }, [props.searchButtonPressed]);

    const data = React.useMemo(() => tableData, [tableData]);

    async function populateTableStatusData() {
        setIsLoading(true);
        const response = await fetch(`form/submissionEagle`);
        const data = await response.json();
        setTableData(data);
        setIsLoading(false);
        
    }

    async function redirectEagle() {
        try {
            const response = await fetch(`/form/redirectEagle`);
            if (response.ok) {
                const url = await response.text();
                window.location.href = url;
            } else {
                console.error('Network response was not ok.');
            }
        } catch (error) {
            console.error('Fetch operation failed:', error);
        }
    }

    
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 10 } // set initial page size and index
        },
        usePagination // enable pagination
    )


    const tableStatus = <>
        <table className="tb-status" {...getTableProps()}>
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {page.map(row => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
        <div className="pagination">
            {/*<button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>*/}
            {/*    {'<<'}*/}
            {/*</button>*/}
            <button className="bt-image">
                <i className="fa fa-angle-left" onClick={() => previousPage()} disabled={!canPreviousPage}></i>
                {/*<img src={require('./prev-button.png')} width="50px" alt="menu" onClick={() => previousPage()} disabled={!canPreviousPage} />*/}
            </button>
            <span >
                Page{' '}
                <strong>
                    {pageIndex + 1} of {pageOptions.length}
                </strong>{' '}
            </span>
            <button className="bt-image">
                <i className="fa fa-angle-right" onClick={() => nextPage()} disabled={!canNextPage}></i>
                {/*<img src={require('./next-button.png')} width="50px" alt="menu" onClick={() => nextPage()} disabled={!canNextPage} />*/}
            </button>
        </div>
    </>
        
    return (
        <div>
            {/*<label className="label-submission" >{'Earnings'}</label>*/} {/*Comm by Gautam*/ }
            {/*<EagleRedirect></EagleRedirect>*/}
            {/*<TableEagleEarnings></TableEagleEarnings>*/} {/*Comm by Gautam*/}
            <div className= "div-eagle-section">
                <label className="label-submission" >{'Profile'}</label>
                {tableData.length > 0 ? (
                    <table className="info-table">
                        {/*<tr className="info-row">*/}
                        {/*    <th className="info-header">Driver Name</th>*/}
                        {/*    <td className="info-data">{tableData[0].driverName}</td>*/}
                        {/*</tr>*/}
                        {/*<tr className="info-row">*/}
                        {/*    <th className="info-header">City Name</th>*/}
                        {/*    <td className="info-data">{tableData[0].cityName}</td>*/}
                        {/*</tr>*/}

                        <tr className="info-row">
                            <th className="info-header">Opted-In</th>
                            <td className="info-data">
                                {
                                    tableData[0].eagle === "True" ?
                                        <i className="fas fa-check-circle" style={{ color: '#0a9830' }}></i> :
                                        <i className="fa fa-times-circle" style={{ color: 'red' }}></i>
                                }
                            </td>
                        </tr>
                        <tr className="info-row">
                            <th className="info-header">Opt-out Attempts</th>
                            <td className="info-data">{tableData[0].optOutCount>0 ? 0 : 1} / 3</td>
                        </tr>
                        <tr className="info-row">
                            <th className="info-header">Bonus</th>
                            <td className="info-data">
                                {tableData[0].eligibleBonus == '0' ? (
                                    <i className="fa fa-times-circle" style={{ color: 'red' }} />
                                ) : (
                                    <i className="fas fa-check-circle" style={{ color: '#0a9830' }}></i>
                                )}
                            </td>

                        </tr>
                        <tr className="info-row">
                            <th className="info-header">No. of Days</th>
                            <td className="info-data">  
                                {tableData[0].noDays}
                            </td>

                        </tr>
                        <tr className="info-data">
                            <th className="info-header">Total Completed Trips</th>
                            <td className="info-data">
                                {
                                    <>
                                        {tableData[0].noRides}
                                        <div style={{ fontSize: '12px', color: '#888' }}>
                                                Last updated: {tableData[0].updatedDateTime}
                                        </div>
                                    </>
                                }
                            </td>
                        </tr>
                    </table>
                ) : (
                        <img src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif" alt="loading" style={{ opacity: '50%',padding: '80px 0px 80px 0px' }} />
                )}
            </div>
            {/*<div className="div-eagle-section">*/}
            {/*    <label className="label-submission" >{'Activity Log'}</label>*/}
            {/*    <br />*/}
            {/*    {tableData.length > 0 && !isLoading ? (*/}
            {/*        <React.Fragment>{tableStatus}</React.Fragment>*/}
            {/*    ) : (*/}
            {/*            <img src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif" alt="loading" style={{ opacity: '50%', padding: '80px 0px 80px 0px' }} />*/}
            {/*        )}*/}
            {/*</div>*/} {/*Comm by Gautam*/}
        </div>
    );

}

export default TableEagleStatus;
